import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { CustomerAuthErrorBanner } from '..'

type AuthCardShellProps = {
  error: string
  closeLabel: string
  onCloseError: () => void
  children: ReactNode
}

export const AuthCardShell = ({ error, closeLabel, onCloseError, children }: AuthCardShellProps) => (
  <motion.div
    initial={{ opacity: 0, y: 20, scale: 0.98 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    transition={{ duration: 0.35, ease: 'easeOut' }}
    className="ca-theme-transition relative overflow-hidden rounded-2xl bg-(--color-bg-card) p-4 sm:p-6"
  >
    <CustomerAuthErrorBanner
      error={error}
      closeLabel={closeLabel}
      onClose={onCloseError}
    />
    {children}
  </motion.div>
)
